import {
  hide,
  Intercom,
  onHide,
  onShow,
  show,
  shutdown,
} from "@intercom/messenger-js-sdk";
import { useEffect, useState } from "react";

export const useBugBountyController = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleClick = () => {
    isVisible ? hide() : show();
  };

  useEffect(() => {
    Intercom({
      app_id: process.env.NEXT_PUBLIC_INTERCOM_APP_ID ?? "",
      hide_default_launcher: true,
    });

    onShow(() => {
      setIsVisible(true);
    });

    onHide(() => {
      setIsVisible(false);
    });

    return () => {
      shutdown();
    };
  }, []);

  return { handleClick };
};
